import React from 'react';
var extendChildrenWithProps = function (children, onItemClick) {
    return React.Children.map(children, function (child) {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                onClick: onItemClick,
            });
        }
        else {
            return child;
        }
    });
};
var WelcomeScreen = function (_a) {
    var logo = _a.logo, onItemClick = _a.onItemClick, children = _a.children, GlobalSearch = _a.GlobalSearch;
    return (React.createElement("div", { className: "welcomeScreen__container" },
        React.createElement("div", { className: "welcomeScreen__content" },
            logo !== undefined && React.createElement("img", { src: logo, alt: 'Welcome Screen Logo' }),
            GlobalSearch,
            React.createElement("div", { className: "welcomeScreen__menu" }, extendChildrenWithProps(children, onItemClick)))));
};
export default WelcomeScreen;
//# sourceMappingURL=WelcomeScreen.js.map